module.exports = __webpack_public_path__ + "img/farmingtoken.3c17bbb.png";